import { useSelector } from 'react-redux';

import { isMobileUa } from '../../shared/features/uatraits';

export const useIsOneColLayout = () => {
    const isMobile = useSelector(isMobileUa);
    return isMobile;
};
